import React, { useState } from 'react';
import * as R from 'ramda';
import Box from '@mui/material/Box';
import { useMediaQuery } from '@mui/material';
import { useParams } from 'react-router-dom';
import TrailerHeader from './header/TrailerHeader';
import CardsDrawer from './CardsDrawer';
import LocationCardList from './LocationCardList';
import CreateTrailerWizard from './create-trailer-wizard/CreateTrailerWizard';
import EditTrailerDrawer from './EditTrailerDrawer';
import ViewTrailerDrawer from './ViewTrailerDrawer';
import { useViewTrailerSummaryByTrailerQuery } from '../trailerStatusEndpoints';

const containerStyles = {
  /* eslint-disable-next-line */
  bgcolor: 'surface.light',
  mt: { md: 6, xs: 0 },
  pb: { md: 0, xs: 8 },
  pl: { md: 37.5, xs: 1 },
  pr: { md: 0, xs: 1 },
};

const boxStyles = {
  display: 'grid',
  gap: 3,
  gridTemplateColumns: `repeat(auto-fit, 300px)`,
  ml: 3,
};

const defaultFilters = { location: '' };

const ViewLocationDetailsByTrailer = () => {
  const lgUp = useMediaQuery(theme => theme.breakpoints.up('lg'), { noSsr: true });

  const [createTrailerOpened, openCreateTrailer] = useState(false);
  const [editTrailerId, setEditTrailerId] = useState('');
  const [viewTrailerId, setViewTrailerId] = useState('');
  const [cardsFilters, setCardsFilters] = useState(defaultFilters);

  const { viewById } = useParams();

  const handleCreateTrailerOpen = R.compose(openCreateTrailer, R.T);
  const handleCreateTrailerClose = R.compose(openCreateTrailer, R.F);
  const handleEditTrailerClose = R.compose(setEditTrailerId, R.always(''));
  const handleViewTrailerClose = R.compose(setViewTrailerId, R.always(''));

  const handleResetFilters = () => {
    setCardsFilters(defaultFilters);
  };

  const handleRemoveFilter = label => {
    setCardsFilters(current => R.assoc(label, defaultFilters[label], current));
  };
  // prettier-ignore
  const trailersFilter = R.compose(
    R.equals(viewById),
    R.prop('trailerId'),
  );

  const {
    data = [],
    isLoading,
    isSuccess,
  } = useViewTrailerSummaryByTrailerQuery(undefined, {
    skip: R.isNil(viewById),
  });

  const trailer = data.find(trailersFilter) ?? {};

  return (
    <>
      {lgUp ? (
        <Box sx={containerStyles}>
          <TrailerHeader
            cardsFilters={cardsFilters}
            defaultFiltersState={defaultFilters}
            isLoading={isLoading}
            isSuccess={isSuccess}
            onCreateTrailer={handleCreateTrailerOpen}
            onRemoveFilter={handleRemoveFilter}
            onResetFilters={handleResetFilters}
            setCardsFilters={setCardsFilters}
            setViewTrailerId={setViewTrailerId}
            trailerData={trailer}
          />
          <Box sx={boxStyles}>
            <LocationCardList locationFilterValue={cardsFilters.location} trailerData={trailer} />
          </Box>
        </Box>
      ) : (
        <CardsDrawer
          backlabel="Back to Trailers"
          cardsFilters={cardsFilters}
          onCreateTrailer={handleCreateTrailerOpen}
          onResetFilters={handleResetFilters}
          onViewTrailer={setViewTrailerId}
          open={!!viewById}
          setCardsFilters={setCardsFilters}
        >
          <LocationCardList locationFilterValue={cardsFilters.location} trailerData={trailer} />
        </CardsDrawer>
      )}
      {createTrailerOpened && <CreateTrailerWizard onClose={handleCreateTrailerClose} />}
      {editTrailerId && (
        <EditTrailerDrawer onClose={handleEditTrailerClose} trailerId={editTrailerId} />
      )}
      {viewTrailerId && (
        <ViewTrailerDrawer
          onClose={handleViewTrailerClose}
          onEdit={setEditTrailerId}
          trailerId={viewTrailerId}
        />
      )}
    </>
  );
};

export default ViewLocationDetailsByTrailer;
